import React from "react";
import Header from "./Header";
//import AccountHeader from "../feature/Common/AccountHeader";
//import SideBar from "./SideBar";
import Footer from "./Footer";
//import { Outlet } from "react-router-dom";
import ChatbotControl from "../components/Chatbot/ChatbotControl";
// import useScript from "../hooks/useScript";

export default function MainLayout({ children }) {
  // useScript("/assets/js/app.js");
  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <Header />
        {/* <AccountHeader /> */}
        {/* <SideBar /> */}
        <ChatbotControl></ChatbotControl>
        {children}

        <Footer />
      </div>
    </React.Fragment>
  );
}
